import { type ApiDef, type ConnectorTarget } from '@blaze-shared/api-contracts-domain';
import {
  type ConnectorConfiguration,
  type ConnectorCreationRequest,
  type ConnectorTemplate,
} from '@blaze-shared/connectors-domain';
import { type BlazeTable, type LinkedBlazeTableConnector } from '@blaze-shared/datasets-domain';
import { type DatasetSchema } from '@blaze-shared/schema-domain';
import { type SelectOption } from '@blaze-shared/shared-util';

export interface ConnectorDialogData {
  action?: ConnectorDialogAction; // Determine what to do with given data
  connector?: ConnectorConfiguration; // connector configuration
  connectorCreationRequest?: ConnectorCreationRequest; // used in connectors that can be created from outside of blaze
  customApiDefinition?: ApiDef; // rest api to preview
  googleSheets?: ConnectorTemplate;
  linkedTableConnector?: LinkedBlazeTableConnector; // linked blaze table from another project
  previewDataset?: DatasetSchema; // dataset to preview
  previewTable?: BlazeTable; // blaze table to preview
  table?: BlazeTable; // blaze table configuration
  template?: ConnectorTemplate; // connector template
  projectGroupId?: string; // id of the project group to which the
}

export enum DialogPage {
  Undetermined = 'undetermined',
  BlazeTable = 'blaze table',
  Datasets = 'datasets',
  PreviewDataset = 'preview dataset',
  PreviewTable = 'preview table',
  RestApi = 'rest api',
  Setup = 'setup',
  ShopifyWizard = 'shopify wizard',
  LinkedBlazeTable = 'linked blaze table',
  ConnectorWizard = 'connector wizard',
}

export type ConnectorDialogAction = 'preview' | 'create' | 'editConnector' | 'editDatasets';

export interface MappingOption<T = string, C = string> extends SelectOption<T> {
  columns: SelectOption<C>[];
}

export type RenderMode = 'dialog' | 'panel';

export const selfManagedConnectors = new Set<ConnectorTarget>([
  'Aircall',
  'Airtable',
  'Cal.com',
  'Calendly',
  'DocuSign',
  'Dropbox',
  'DropboxSign',
  'GoogleAnalytics',
  'GoogleCalendar',
  'GoogleMail',
  'GoogleSheets',
  'InBody',
  'LifeFile',
  'MailGun',
  'MicrosoftTeams',
  'OneDrive',
  'OpenAI',
  'PioneerRx',
  'QuickBooks',
  'Salesforce',
  'ScriptSure',
  'Shopify',
  'Square',
  'Stripe',
  'Twilio',
  'Typeform',
]);
